import { apiRequest } from './api';

export const memberSearchService = {
  searchMembers: async ({ search = '', limit = 12, feesStatus = 'all', signal } = {}) => {
    const trimmedSearch = search.trim();

    if (!trimmedSearch) {
      return { members: [] };
    }

    const params = new URLSearchParams({
      search: trimmedSearch,
      limit: String(limit),
    });

    if (feesStatus && feesStatus !== 'all') {
      params.set('feesStatus', feesStatus);
    }

    return await apiRequest(`/admin/member-search?${params.toString()}`, {
      method: 'GET',
      includeAuth: true,
      signal,
    });
  }
};